import {createSlice} from "@reduxjs/toolkit";

const initialInvestigationState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    investigationToView: undefined,
    lastError: null
}

export const callTypes = {
    list: "list",
    action: "action"
}

export const investigationsSlice = createSlice({
    name: "investigations",
    initialState: initialInvestigationState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // find Invoices
        investigationsFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },

        // get Invoice

        investigationFetched: (state, action) => {
            state.actionsLoading = false;
            state.investigationToView = action.payload.investigationToView;
            state.error = null;
        },

        // create Invoice
        investigationCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.investigation);
        },
        investigationDeleted: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        }
    }
})